module.exports = __webpack_public_path__ + "img/order-btn.0ed3172f.png";